module.exports = __webpack_public_path__ + "ad72c902078840e7ea3151903e7c2760.pdf";